// extracted by mini-css-extract-plugin
export default {"imageLong":"ImageLong_imageLong__2TfN+","imageHeight":"ImageLong_imageHeight__p1QSQ"};